import React, { forwardRef } from "react"
import { MenuContainer } from "./style"

const Menu = forwardRef(({ className, ...props }, ref) => (
  <MenuContainer {...props} ref={ref} className={className} />
))

export default Menu